// The visitor's cookie choice: the one place that reads and writes it.
//
// Nothing that measures visitors may run unless the choice is "granted". No
// answer and "denied" are the same thing: nothing loads. The choice is kept
// in a first-party cookie (it has to outlive the visit to be honoured on the
// next one) under the name and values the banner has always written, so
// choices made before this module existed still count. It is read fresh on
// every check, so a change made in another tab applies here too.
import { CONSENT_COOKIE, GRANTED, readConsent } from '@/lib/privacyRules';

const DAYS = 365;
const CHANGED = 'nsofar:consent-changed';
const OPEN_SETTINGS = 'nsofar:cookie-settings';

export function getConsent() {
  return readConsent(document.cookie);
}

export function hasAnalyticsConsent() {
  return getConsent() === GRANTED;
}

export function setConsent(value) {
  const expires = new Date(Date.now() + DAYS * 86400000).toUTCString();
  const secure = window.location.protocol === 'https:' ? ';Secure' : '';
  document.cookie = `${CONSENT_COOKIE}=${value};expires=${expires};path=/;SameSite=Lax${secure}`;
  window.dispatchEvent(new Event(CHANGED));
}

export function onConsentChange(listener) {
  window.addEventListener(CHANGED, listener);
  return () => window.removeEventListener(CHANGED, listener);
}

// "Cookie settings" links call this. The banner listens and opens again with
// the current choice shown, so a visitor can change their mind at any time.
export function openCookieSettings() {
  window.dispatchEvent(new Event(OPEN_SETTINGS));
}

export function onCookieSettingsOpen(listener) {
  window.addEventListener(OPEN_SETTINGS, listener);
  return () => window.removeEventListener(OPEN_SETTINGS, listener);
}
